module.exports = __webpack_public_path__ + "static/media/FLC Logo.e7cf564d.jpeg";